// @flow

import * as React from 'react';

import clsx from 'clsx';

import styles from 'src/Domain/ProvidedContainerLayout.scss';

import { PriceArea } from '../PriceArea';
import { BundlePrice } from '../PriceArea/BundlePrice';
import { useDomainBundle } from '../modules';

import { BundleDescription } from './BundleDescription';

import stylesBundle from './DomainBundle.scss';

export function DomainBundle({
  className,
  fqdn,
}: {
  className?: string,
  fqdn: string,
}): React.MixedElement | null {
  const { loading, addBundle, removeBundle, allInTheCart } = useDomainBundle();

  return (
    <div id={fqdn} className={clsx(stylesBundle.root, styles.root, className)}>
      <BundleDescription />
      <div className={styles.containerPrices}>
        <PriceArea
          loading={loading}
          addedToCart={allInTheCart}
          onClick={allInTheCart ? removeBundle : addBundle}
          isCartActionnable
        >
          <BundlePrice />
        </PriceArea>
      </div>
    </div>
  );
}
